import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    fieldHeader: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    optionRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    container: {
        flexDirection: "column",
        width: "100%",
        flex: 1
    },
    cardContainer: {
        flexDirection: "column",
        borderStyle: "solid",
        width: "100%"
    },
    contentContainer: {
        flexDirection: "column",
        width: "100%"
    },
    formGroup: {
        flexDirection: "column",
        width: "100%"
    },
    fieldContainer: {
        flexDirection: "column",
        borderStyle: "solid",
        width: "100%"
    },
    fieldBody: {
        flexDirection: "column",
        width: "100%"
    },
    optionsContainer: {
        flexDirection: "column",
        width: "100%"
    },
    headerBackContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    rowGroup: {
        flexDirection: "row",
        alignItems: "center",
        width: "100%"
    },
    optionInput: {
        flex: 1
    }
});

export default stylesheet;
